import { postMultipart } from '@/lib/multipart';
import type { TimeSheetSignatureTypeReference } from '@/models/references/references';
import { resolveReference } from '@/stores/useReferenceOptions';

/**
 * Signe la feuille avec la signature dessinée (PNG, SignaturePad) : l'API la fait avancer (Employé : soumission ;
 * Dirigeant : validation) et stocke l'image avec la signature, en multipart. Erreurs non affichées : le dialogue qui
 * appelle les montre.
 */
export async function signTimeSheet(sheetUrn: string, type: TimeSheetSignatureTypeReference, image: Blob) {
  const signatureType = await resolveReference('timeSheetSignatureTypes', type);
  await postMultipart('/time_sheet_signatures', {
    timeSheet: sheetUrn,
    timeSheetSignatureType: signatureType.urn,
    image: new File([image], 'signature.png', { type: 'image/png' }),
  });
}
